/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drab_Zany_Fish_TendInputs */

const es_drab_zany_fish_tend = /** @type {(inputs: Drab_Zany_Fish_TendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso legal`)
};

const gl_drab_zany_fish_tend = /** @type {(inputs: Drab_Zany_Fish_TendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviso legal`)
};

const en_drab_zany_fish_tend = /** @type {(inputs: Drab_Zany_Fish_TendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal notice`)
};

/**
* | output |
* | --- |
* | "Legal notice" |
*
* @param {Drab_Zany_Fish_TendInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const drab_zany_fish_tend = /** @type {((inputs?: Drab_Zany_Fish_TendInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drab_Zany_Fish_TendInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_drab_zany_fish_tend(inputs)
	if (locale === "en") return en_drab_zany_fish_tend(inputs)
	return es_drab_zany_fish_tend(inputs)
});